import React, { FC, memo } from 'react';
import { Button, ButtonSize, ButtonVariant, CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { Stack } from '@mui/material';
import { DataTableFilterButtonProps } from './types';

export const DataTableFilterButton: FC<DataTableFilterButtonProps> = memo(
  ({ isShown, name, text, ariaText, onClick }) =>
    isShown ? (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          name={name}
          size={ButtonSize.SMALL}
          variant={ButtonVariant.SECONDARY}
          onClick={onClick}
          text={{ value: text }}
          ariaText={{ value: ariaText }}
          leadingIcon={() => <CmhcIcon size={CmhcIconSize.SMALL} type="icon_filter" />}
        />
      </Stack>
    ) : null
);
